import clsx from 'clsx';

export function Spinner({ className }: { className?: string }) {
  return (
    <svg
      className={clsx('animate-spin', className ?? 'h-5 w-5')}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
      <path
        className="opacity-90"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

/**
 * Shown while the app decides whether there is a session.
 *
 * A logo-led hold rather than a bare spinner: this is the very first thing a
 * returning user sees, and a branded frame reads as "loading the app" where a
 * lone spinner reads as "something is stuck".
 */
export function FullPageSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg">
      <div className="animate-fade-in flex flex-col items-center gap-4">
        <div className="relative">
          <div className="flex h-12 w-12 items-center justify-center bg-accent text-lg font-extrabold text-accent-fg">
            S
          </div>
          <Spinner className="absolute -inset-2 h-16 w-16 text-accent/30" />
        </div>
        <p className="text-sm text-muted">{label}…</p>
      </div>
    </div>
  );
}
